export default __webpack_public_path__ + "media/images/images_v2/onglet-gauche-home-8fb1abae5a8f9cfa81e09a503f0c6495.png";